import { useInfiniteQuery } from "@tanstack/react-query";
import { ApiGetClosedOrderList } from "@/api";
import type { ClosedOrderMode, GetClosedOrderListResponse } from "@/api/types";

/**
 * 获取已平仓订单列表（滚动分页）
 * 对应接口：`/game/cex/GetClosedOrderList`
 *
 * 约定：
 * - 每次固定拉取 100 条
 * - 使用 `useInfiniteQuery` 做无限滚动分页
 */
export function useGetClosedOrderList(orderMode: ClosedOrderMode = "all") {
  const pageSize = 100;

  return useInfiniteQuery({
    queryKey: ["closedOrderList", pageSize, orderMode],
    initialPageParam: 1,
    queryFn: async ({ pageParam }): Promise<GetClosedOrderListResponse> => {
      const page =
        typeof pageParam === "number" && pageParam > 0 ? pageParam : 1;
      const res = await ApiGetClosedOrderList({ page, pageSize, orderMode });
      console.log("useGetClosedOrderList", res.data);
      return res.data;
    },
    getNextPageParam: (lastPage, allPages) => {
      const fetchedCount = allPages.reduce(
        (acc, page) => acc + (page.items?.length ?? 0),
        0
      );
      if (fetchedCount >= (lastPage.total ?? 0)) return undefined;
      if ((lastPage.items?.length ?? 0) === 0) return undefined;
      return allPages.length + 1;
    },
  });
}
